import React from "react";
import textWeight from "../../utils/textWeight";
import { fontSizes } from "../../constants/constants";
import Text from "../Text";
import { ReactSVG } from "react-svg";

export default function MainHeading(props) {
  const { TextWeight } = textWeight();
  return (
    <div className="mb-7 lg:mb-10">
      <div className="flex">
        <ReactSVG
          src={props.Icon}
          beforeInjection={(svg) => {
            svg.classList.add("w-10", "md:w-12", "h-auto");
          }}
        />
        <Text
          text={props.heading}
          size={fontSizes.h36}
          weight={TextWeight.Raleway_ExtraBold}
          color="text-black"
          isTruncate={false}
          className={"pl-4"}
        />
      </div>
      <Text
        text={props.paragraph}
        size={fontSizes.h18}
        weight={TextWeight.Raleway_SemiBold}
        color="text-black"
        isTruncate={false}
        className={"pl-12"}
      />
    </div>
  );
}
